import { WithPlanBadge } from '@/shared/components/Badge/PlanBadge';
import { useUpsellingGuard, useUserPlanManager } from '@/shared/plan';
import { EditTools } from '../../EditTools';
import { useAiGenerateSingleSimilarAnswer } from './useAiGenerateSingleSimilarAnswer';
interface AiGenerateSingleSimilarAnswerButtonProps {
  answerIndex: number;
}
export const AiGenerateSingleSimilarAnswerButton = ({
  answerIndex
}: AiGenerateSingleSimilarAnswerButtonProps) => {
  const {
    generate,
    disabled
  } = useAiGenerateSingleSimilarAnswer(answerIndex);
  const upsellingGuard = useUpsellingGuard();
  const {
    userPlanManager
  } = useUserPlanManager();
  const featurePlanType = userPlanManager.getFeaturePlanType('AI_ANSWER_GENERATION');
  return <WithPlanBadge planType={featurePlanType} isBadgeVisible={true} data-sentry-element="WithPlanBadge" data-sentry-component="AiGenerateSingleSimilarAnswerButton" data-sentry-source-file="AiGenerateSingleSimilarAnswerButton.tsx">
      <EditTools.AiAnswerGenerationButton disabled={disabled} onClick={() => {
      void upsellingGuard(() => generate(answerIndex), {
        feature: 'AI_ANSWER_GENERATION',
        from: 'ai'
      });
    }} data-sentry-element="unknown" data-sentry-source-file="AiGenerateSingleSimilarAnswerButton.tsx" />
    </WithPlanBadge>;
};